import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GuideStyles from "assets/js/guide";
import { Box, Tabs, Tab } from "@mui/material";

export default function GuideDrawer() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2">
          <div className="h-group">
            <h2 className="guide-h2">Tabs</h2>
          </div>

          <h3 className="guide-h3">Scrollable tabs</h3>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <Tab label="Item One" />
            <Tab label="Item Two" />
            <Tab label="Item Three" />
            <Tab label="Item Four" />
            <Tab label="Item Five" />
            <Tab label="Item Six" />
            <Tab label="Item Seven" />
          </Tabs>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Full width</h3>
        </Box>
      </main>
    </>
  );
}
